import React from "react";

interface EnlargedImageOverlayProps {
  image: string | boolean;
  onClose: () => void;
}

export const EnlargedImageOverlay: React.FC<EnlargedImageOverlayProps> = ({
  image,
  onClose,
}) => {
  if (!image) return null;

  return (
    <div
      className="w-full h-full absolute top-0 left-0 flex items-center justify-center backdrop-brightness-50"
      onClick={onClose}
    >
      {typeof image === "string" && (
        <img src={image} alt="enlarge" className="m-auto" />
      )}
    </div>
  );
};
